import React, {useEffect, useState} from 'react'
import {
  InfoDemandeImmatSelected,
  ModeleEditCentre,
  ModeleImmatriculation,
} from '../../../../components/Models'
import {
  getCatdata,
  getCentres,
  getOneVehicleHorsType,
  getOneVehicleModele,
} from '../../../../components/requests'
import VehicleData from './VehicleData'
import {Tooltip} from 'react-tooltip'
import {TransfertCentreModal} from '../TransfertCentreModal'
import {useAuth} from '../../../modules/auth'
import {Link} from 'react-router-dom'
import {copyText} from '../../../../components/renders'

const VehicleInfo = (props) => {
  const {
    data,
    tempsEcoule,
    immatsArray,
    setAssign,
    clientId,
    redirectToClientDemande,
    onEdit,
    setImmatsArray,
    demandeId,
    setShowDetailVehicule,
    showDetailVehicule,
    fromTraitement,
    isFromClient,
    canEdit = true
  } = props
  const userConnected = useAuth()
  const [immatriculation, setImmatriculation] = useState<ModeleImmatriculation>({})
  const [loading, setLoading] = useState<{[key: string]: boolean}>({})
  const [immatriculationValide, setImmatriculationValide] = useState<boolean>(false)
  const [infoModele, setInfoModele] = useState<any>([])
  const [vehicleInfo, setVehiculeInfo] = useState<boolean>(true)
  const [centres, setCentres] = useState<Array<ModeleEditCentre>>([])
  const [centreSelected, setCentreSelected] = useState<{value: number; label: string}>()
  const [infoSelected, setInfoSelected] = useState<InfoDemandeImmatSelected>({
    idDemande: null,
    immat: '',
    idModele: null,
    idVehicleHorsType: null,
  })
  const [checkCopy, setCheckCopy] = useState<string | null>(null)


  const verifyCatdata = async (immat: string) => {
    if (!immat) return

    setVehiculeInfo(true)
    setLoading((prev) => ({...prev, [immat]: true}))

    try {
      const immatriculationRequest = await getCatdata(immat)
      if (immatriculationRequest?.status === 200 && immatriculationRequest?.data) {
        setImmatriculation(immatriculationRequest.data)
        setImmatriculationValide(true)
        setInfoModele([])
        setVehiculeInfo(false)
        setShowDetailVehicule(true)
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setLoading((prev) => ({...prev, [immat]: false}))
    }
  }

  const getCentresData = () => {
    let centreIds: string | undefined = ''
    if (userConnected) {
      let userCentre = userConnected?.currentUser?.listeCentres?.[0]
      if (userCentre?.length > 0) {
        centreIds = userCentre?.map((centre) => centre?.id)?.join(',')
      }
    }

    getCentres(1, '', centreIds)
      .then((centresRequest) => {
        if (centresRequest?.data !== undefined) {
          const transformedData = centresRequest.data.map((item) => ({
            value: item.id,
            label: item.nom,
          }))
          setCentres([...transformedData])
        }
      })
      .catch((e) => {})
  }

  useEffect(() => {
    getCentresData()
  }, [])


  // gestion de la sélection de centre
  const handleCentreChange = (selectedOptions) => {
    setCentreSelected(selectedOptions)
  }

  const handleImmatInfo = (e) => {
    const newVal = immatsArray.map((item) =>
      item.label === infoSelected.immat ? {...item, centreLabel: e} : item
    )
    setImmatsArray(newVal)
  }

  const handleInfoSelected = (e) => {
    setInfoSelected({
      idDemande: data.id,
      immat: e.value,
      idModele: e.idModele,
      idVehicleHorsType: e.idHorsType,
    })
    setCentreSelected({value: 0, label: e.centreLabel})
  }

  const verifyModData = async (idModele: string, isViaModele: boolean) => {
    if (!idModele) return

    setVehiculeInfo(true)
    setLoading((prev) => ({...prev, [idModele]: true}))

    try {
      let action = isViaModele ? getOneVehicleModele : getOneVehicleHorsType
      const res = await action(idModele)
      if (res?.status === 200 && res?.data) {
        setImmatriculation({})
        if (isViaModele) {
          setInfoModele([{...res.data, isHorsType: false}])
        } else {
          setInfoModele([{...res.data, marque: {nom: res.data.marque}, isHorsType: true}])
        }
        setImmatriculationValide(true)
        setVehiculeInfo(false)
        setShowDetailVehicule(true)

      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setLoading((prev) => ({...prev, [idModele]: false}))
    }
  }

  const showInfo = (data: any, viaModele: boolean, vHorsType: boolean) => {
    if (viaModele || vHorsType) {
      verifyModData(data, viaModele)
    } else {
      verifyCatdata(data)
    }
  }

  const handleCopie = (texte, e) => {
    e.stopPropagation()
    copyText(texte, setCheckCopy, 500)
  }


  const renderFormRowImmat = () => {
    let im = ''
    return immatsArray?.map((object, index) => {
      let isViaModele = false
      let isVehicleHorsType = false
      im = object.value
      if (object?.idModele) {
        im = object?.immatriculationNonTrouvee ? object?.immatriculationNonTrouvee + ' [NT]' : ''
        isViaModele = true
      } else if (object?.idHorsType) {
        im = ''
        isVehicleHorsType = true
      }
      // console.log('im', im)
      return (
        <tr key={index}
          className={'cursor-pointer'}
          onClick={() =>
            showInfo(
              isViaModele ? object?.idModele : object?.idHorsType ?? object.value,
              isViaModele,
              isVehicleHorsType
            )
        }>
          <td>
            <div className='d-flex gap-3 text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
              {im}
              {im &&
                (checkCopy !== im ? (
                  <i
                    className='ki-duotone ki-copy cursor-pointer fs-2'
                    onClick={(e) => handleCopie(object.value, e)}
                  ></i>
                ) : (
                  <i className='ki-duotone ki-copy-success text-primary fs-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                ))}
            </div>
          </td>
          <td>
            <div className='d-flex gap-3 align-items-center gap-2'>
              {object?.vin}
              {object?.vin &&
                (checkCopy !== object.vin ? (
                  <i
                    className='ki-duotone ki-copy cursor-pointer fs-2'
                    onClick={(e) => handleCopie(object?.vin, e)}
                  ></i>
                ) : (
                  <i className='ki-duotone ki-copy-success fs-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                ))}
            </div>
          </td>
          <td>{object.centreLabel}</td>
          <td>{object?.marque}</td>
          <td>
            {object?.modele} {isVehicleHorsType && ' [VHT]'}
          </td>
          <td>{object?.datePme}</td>
          <td>
            <div className='d-flex gap-3'>
              {loading[isViaModele ? object?.idModele : object?.idHorsType ?? object.value] ? (
                <span className='btn btn-icon btn-bg-light btn-sm'>
                  <span className='spinner-border spinner-border-sm align-middle'></span>
                </span>
              ) : (
                <>
                  <span
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    style={{cursor: 'pointer'}}
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Détail du véhicule'
                    data-tooltip-place='right'
                  >
                    <i
                      className='ki-duotone ki-information-2 fs-2x btn-active-color-info'
                      onClick={() =>
                        showInfo(
                          isViaModele ? object?.idModele : object?.idHorsType ?? object.value,
                          isViaModele,
                          isVehicleHorsType
                        )
                      }
                    >
                      <span className='path1'></span>
                      <span className='path2'></span>
                      <span className='path3'></span>
                    </i>
                  </span>

                  {/*<i*/}
                  {/*  className='bi bi-arrows-angle-contract fs-2'*/}
                  {/*  style={{cursor: 'pointer'}}*/}
                  {/*  data-bs-toggle='modal'*/}
                  {/*  data-bs-target='#kt_modal_transfert'*/}
                  {/*  data-bs-dismiss='true'*/}
                  {/*  data-tooltip-id='tooltip'*/}
                  {/*  data-tooltip-content='Transférer'*/}
                  {/*  data-tooltip-place='bottom'*/}
                  {/*  onClick={() => handleInfoSelected(object)}*/}
                  {/*></i>*/}
                </>
              )}
            </div>
          </td>
        </tr>
      )
    })
  }

  return (
    <>
      <div className='row'>
        <div className='d-flex justify-content-between'>
          <h3>Liste des véhicules</h3>
          <div className='d-flex align-items-center gap-3 mb-3'>
            {(canEdit && (data.clientDemandeEtape.code == 'NOUVE' ||
              data.clientDemandeEtape.code == 'ASSIG' ||
              data.clientDemandeEtape.code == 'MODIF' ||
              data.clientDemandeEtape.code == 'PROPO')) && (
              <span className='btn btn-icon btn-bg-light btn-sm'>
                <Link
                  to={`/demandes/${clientId}/edit/${demandeId}`}
                  state={{
                    demandeId: demandeId,
                    immat: [],
                    isFromClient: isFromClient,
                    fromTraitement: fromTraitement,
                  }}
                >
                  <i
                    key={demandeId}
                    className='ki-duotone ki-pencil fs-2x'
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Modifier la demande'
                    data-tooltip-place='right'
                  >
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                </Link>
              </span>
            )}
          </div>
        </div>
        <div className={`${showDetailVehicule && 'd-flex gap-6'}`}>
          {/*// {!immatriculationValide ? (*/}
          <div className={`table-responsive ${showDetailVehicule && 'col-7'}`}>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='min-w-100px'>Immatriculation</th>
                  <th className='min-w-150px'>VIN</th>
                  <th className='min-w-150px'>Centre</th>
                  <th className='min-w-150px'>Marque</th>
                  <th className='min-w-150px'>Modèle</th>
                  <th className='min-w-100px'>Date 1ère circulation</th>
                  <th className=''>Actions</th>
                </tr>
              </thead>
              <tbody className='min-height'>{renderFormRowImmat()}</tbody>
            </table>
          </div>
          {/*// ) : (*/}
          {showDetailVehicule && (
            <>
              <VehicleData
                immatriculation={immatriculation}
                setImmatriculationValide={setImmatriculationValide}
                closeBtn={true}
                infoModele={infoModele}
                vehicleInfo={vehicleInfo}
                setShowDetailVehicule={setShowDetailVehicule}
              />
            </>
          )}
          {/*// )}*/}
        </div>
        <TransfertCentreModal
          infoSelected={infoSelected}
          centreSelected={centreSelected}
          centres={centres}
          onCentreChange={handleCentreChange}
          onTransfert={handleImmatInfo}
          handleImmatInfo={handleImmatInfo}
        />
      </div>
      {/*Affichage du tooltip*/}
      <Tooltip id='tooltip' />
    </>
  )
}
export {VehicleInfo}
